module.exports = __webpack_public_path__ + "static/media/headerSmaller.01ce560f.jpg";